import React, { FC } from 'react'
import { Helmet } from 'react-helmet'
import { graphql } from 'gatsby'
import Layout from '@/containers/Layout'
import PageContainer from '@/containers/PageContainer'
import { SanityPage } from 'web/types/graphql-types'
import  Head from '@/containers/Head'

interface PageProps {
  data: {
    page: SanityPage
  }
}

const Page: FC<PageProps> = ({ data: { page }, ...props }) => (
  <Layout>
    <Head title={page.meta?.metaTitle || page.title || undefined} metaData={page.meta || undefined} />
    <PageContainer page={page} />
  </Layout>
)

export default Page

export const query = graphql`
  query($id: String!) {
    page: sanityPage(id: { eq: $id }) {
      title
      meta {
        ...metaData
      }
      contentModules {
        ...contentModulesData
      }
    }
  }
`
